import { useEffect, useState } from 'react';
import { translate } from '../../i18n';
import complianceApi from '../../api/complianceApi';
import useLocationStore from '../../store/locatonStore';
import { IComplianceStaff } from '../../type/complianceStaff';

interface ComplianceSelectBoxProps {
  allocatedTo?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  allocatedStaffId?: number;
  isEditMode?: boolean;
}

export default function ComplianceSelectBox({
  allocatedTo,
  disabled = true,
  onChange,
  allocatedStaffId,
  isEditMode = false,
}: ComplianceSelectBoxProps) {
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const [apiResponse, setApiResponse] = useState<IComplianceStaff[]>([]);
  const [defaultStaffName, setDefaultStaffName] = useState<string | null>(null);

  useEffect(() => {
    fetchStaffList();
  }, [selectedLocation]);

  const fetchStaffList = async () => {
    const response = await complianceApi.getStaffList(selectedLocation.OwnerId);
    const staffList: IComplianceStaff[] = response?.data || [];

    const matched = staffList.find((s) => s.staffId === allocatedStaffId);
    if (!matched && allocatedStaffId) {
      setDefaultStaffName('Unknown Staff');
    }

    setApiResponse(staffList);
  };

  const selectedStaffName =
    apiResponse.find((staff) => staff.staffId === allocatedStaffId)?.staffName ||
    defaultStaffName ||
    'N/A';

  if (!isEditMode) {
    return <p className="text-text-black">{selectedStaffName}</p>;
  }

  return (
    <select
      value={allocatedStaffId}
      onChange={onChange}
      disabled={disabled}
      className="mt-1 block w-full p-2 border border-customBorder-border rounded-md bg-backgroundColor-darkThemeColor text-text-secondary"
    >
      <option className="text-textColorGray" value="">
        {translate('driver.driverSelection')}
      </option>

      {/* If staffId is not in the list but still exists */}
      {defaultStaffName && (
        <option value={allocatedTo}>{defaultStaffName}</option>
      )}

      {apiResponse.map((staff) => (
        <option key={staff.staffId} value={staff.staffId}>
          {staff.staffName}
        </option>
      ))}
    </select>
  );
}
